import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';
import { useForm } from 'react-hook-form';

// store
import { storeSet } from '../../store';

// components
import FormField from '../FormField';
import ButtonFlat from '../ButtonWrapper/components/ButtonFlat';
import ButtonFormSubmit from '../ButtonWrapper/components/ButtonFormSubmit';
import ModalDialog from '../ModalDialog';
import handleSuccessAndDisplay from '../../helpers/handleSuccessAndDisplay';

// styles
import './ModalUploadVideo.css';

const ModalUploadVideo = ({
    projectId,
    onClose
}) => {
    const [loading, setLoading] = useState(false);
    const {
        control,
        handleSubmit,
        formState: { isValid },
        reset
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            video: null
        }
    });

    const onSubmit = async (formData) => {
        setLoading(true);

        try {
            const formDataToSend = new FormData();
            formDataToSend.append('file', formData.video);
            await storeSet('createVideoItem', projectId, formDataToSend);

            handleSuccessAndDisplay(__('Video è stato caricato con successo', 'soundbetween'));
            reset();
            onClose();
        } catch (error) {
            // Error already displayed by store action
        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => {
        reset();
        onClose();
    };

    return (
        <ModalDialog
            additionalClasses={['modalUploadVideo']}
            header={__('Carica video', 'soundbetween')}
            visible={true}
            onSubmit={handleSubmit(onSubmit)}
            onHide={handleCloseModal}>
            <form className="appForm formInModal" onSubmit={handleSubmit(onSubmit)}>
                <FormField
                    control={control}
                    name="video"
                    label={__('Carica file', 'soundbetween')}
                    placeholder={__('Scegli un file video', 'soundbetween')}
                    type="fileupload"
                    accept=".mp4"
                    rules={{
                        required: __('È obbligatorio', 'soundbetween')
                    }}
                />

                <div className="appFormActions">
                    <ButtonFlat size="lg" type="button" onClick={handleCloseModal}>
                        {__('Annulla', 'soundbetween')}
                    </ButtonFlat>
                    <ButtonFormSubmit disabled={loading || !isValid}>
                        {__('Salva', 'soundbetween')}
                    </ButtonFormSubmit>
                </div>
            </form>
        </ModalDialog>
    );
};

export default ModalUploadVideo;
